<div class="bui-row-container">
  <div class="row-icon row-icon-left" *ngIf="leftIconName">
    <bw-icon-legacy iconName="{{leftIconName}}" color="{{leftIconColor}}" backgroundColor="{{leftIconBackgroundColor}}" [size]="leftIconSize"></bw-icon-legacy>
  </div>
  <div class="row-content">
    <ng-content select=".row-content"></ng-content>
  </div>
  <div class="row-value">
    <ng-content select=".row-value"></ng-content>
  </div>
  <div class="row-icon row-icon-right" *ngIf="rightIconName">
    <bw-icon-legacy iconName="{{rightIconName}}" color="{{rightIconColor}}" backgroundColor="{{rightIconBackgroundColor}}"></bw-icon-legacy>
  </div>
</div>
